export const APP_LOCALES = ['en', 'zh-Hans', 'tr', 'bn'] as const;

export type AppLocale = (typeof APP_LOCALES)[number];

export const DEFAULT_LOCALE: AppLocale = 'en';

/** Separate from the shell app key so the two apps do not overwrite each other. */
export const LOCALE_STORAGE_KEY = 'qclive-inspect-locale';

export function isAppLocale(value: string): value is AppLocale {
  return (APP_LOCALES as readonly string[]).includes(value);
}

/** Intl tag for the date filter. English keeps the browser locale so existing date order stays put. */
export function datePickerLocale(language: string): string | undefined {
  if (!isAppLocale(language) || language === DEFAULT_LOCALE) {
    return undefined;
  }
  return intlTagForLocale(language);
}

export function intlTagForLocale(locale: AppLocale): string {
  switch (locale) {
    case 'en':
      return 'en-GB';
    case 'tr':
      return 'tr-TR';
    case 'zh-Hans':
      return 'zh-CN';
    case 'bn':
      return 'bn-BD';
    default: {
      const exhaustive: never = locale;
      return exhaustive;
    }
  }
}

export function languageKeyForLocale(locale: AppLocale): string {
  switch (locale) {
    case 'en':
      return 'language.en';
    case 'tr':
      return 'language.tr';
    case 'zh-Hans':
      return 'language.zhHans';
    case 'bn':
      return 'language.bn';
    default: {
      const exhaustive: never = locale;
      return exhaustive;
    }
  }
}
